import React from 'react';
import { Navigate } from 'react-router-dom';

import { useW2Paths } from './paths';

/** Unknown child segment under a (resolving/resolved) token → register. The URL
 *  carries a valid token and the layout has already resolved it, so stay in the
 *  flow rather than dumping to a token-less 404. Explicit absolute path (avoids
 *  the splat-route relative-`..` resolution subtlety in RR v7). */
export const W2FlowCatchAll: React.FC = () => {
  const paths = useW2Paths();
  return <Navigate to={paths.register} replace />;
};
